module.exports = __webpack_public_path__ + "assets/img/506b7d038e1e8529383e2686394ffef4.png";